import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuditoriaService {

  constructor(private http: HttpClient) { }

  // Formulário
  getUnidadesClientesAssociados() {
    return this.http.get<any>(environment.wsUrl + 'auditoria/getUnidadesClientesAssociados').toPromise();
  }

  getListaAssociacaoAuditoria(params){
    return this.http.post<any>(environment.wsUrl + 'auditoria/listarAssociacaoAuditorUnidade', params).toPromise();
  }

  getListaUsuarios() {
    return this.http.get<any>(environment.wsUrl + 'usuario/lista').toPromise();
  }

  salvarAssociacaoAuditoria(dados) {
    return this.http.post<any>(environment.wsUrl + 'auditoria/criarAssociacaoAuditoria', dados).pipe().toPromise();
  }

  // Tabela
  getListaAssociacaoAuditoriaFiltro(params) {
    return this.http.post<{
      total: number,
      lista: {
        nomeFantasia: string,
        nomeAuditor: string,
      }[]
    }>(environment.wsUrl + 'auditoria/listarAssociacaoAuditoria', params).pipe().toPromise();
  }

  deletarAssociacaoAuditoria(dados, justificativa, ignore = []) {
    return this.http.post(environment.wsUrl + 'auditoria/deletarAssociacaoAuditoria', dados, {
      headers: {
        ignore: ignore,
        justificativa: justificativa
      }
    }).toPromise();
  }

  // Listagem das unidades auditadas
  getListaUnidadesAuditadas(params) {
    return this.http.post<any>(environment.wsUrl + 'auditoria/listarUnidadesQtdAuditores', {
      headers: { ignore: params,}}).pipe().toPromise();
  }

  getListaUnidadesAuditadasFiltro(filter) {
    return this.http.post<{
      total: number,
      lista: {
        nomeFantasia: string,
      }[]
    }>(environment.wsUrl + 'auditoria/listarUnidadesQtdAuditores', filter).pipe(
    ).toPromise();
  }

  // Filtro Auditar Laudo
  getUnidadesClientes() {
    return this.http.get<any>(environment.wsUrl + 'auditoria/getUnidadesClientesAuditoria').toPromise();
  }

  getUnidadesAuditoras() {
    return this.http.get<any>(environment.wsUrl + 'auditoria/getUnidadesAuditoras').toPromise();
  }


  // Busca as unidades clientes quando acessado por um usuário auditor
  getUnidadesAuditoria() {
    return this.http.get<any>(environment.wsUrl + 'auditoria/getUnidadesClientes').toPromise();
  }

  getUsuariosAuditoria() {
    return this.http.get<any>(environment.wsUrl + 'usuario/lista').toPromise();
  }

  getSalvarAssociacaoAuditoria(dados) {
    return this.http.post<any>(environment.wsUrl + 'auditoria/criarAssociacaoAuditorUnidade', dados).pipe().toPromise();
  }

  deleteAssociacaoAuditor(dados, justificativa, ignore = []) {
    return this.http.post(environment.wsUrl + 'auditoria/deletarAssociacaoAuditorUnidade', dados, {
      headers: {
        ignore: ignore,
        justificativa: justificativa
      }
    }).toPromise();
  }

  getListalaudo(dados) {
    return this.http.post<any>(environment.wsUrl + 'auditoria/getListaLaudo', dados).toPromise();
  }

  getListaUnidadesAuditor(){
    return this.http.get(environment.wsUrl + 'auditoria/listaUnidadesAuditor').toPromise();
  }

  getDownloadExcel(data, ignore = ['content-type']) {
    return this.http.post(environment.wsUrl + 'auditoria/getListaLaudoXls', data,
    {
      params: { ignore: ignore }, responseType: 'blob'
    }).toPromise();
  }

}
